// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3J65f","right":"styles_right__y2rt7"};